/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Property_Link_Rule_Type_OpeninappInputs */

const en_enum_custom_property_link_rule_type_openinapp = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_OpeninappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property Link Rule Type Openinapp`)
};

const de_enum_custom_property_link_rule_type_openinapp = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_OpeninappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der App öffnen`)
};

/**
* | output |
* | --- |
* | "Property Link Rule Type Openinapp" |
*
* @param {Enum_Custom_Property_Link_Rule_Type_OpeninappInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_property_link_rule_type_openinapp = /** @type {((inputs?: Enum_Custom_Property_Link_Rule_Type_OpeninappInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Property_Link_Rule_Type_OpeninappInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_property_link_rule_type_openinapp(inputs)
	return de_enum_custom_property_link_rule_type_openinapp(inputs)
});